import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Image, Row, Stack } from "react-bootstrap";

const Github = () => {
  return (
    <div style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        GitHub <strong className="yellow">Stats</strong>
      </h1>

      <Stack mt="70px">
        <Image
          height={"300px"}
          id="github-stats-card"
          src="https://github-readme-stats.vercel.app/api?username=Prabhat-kumar-11&theme=blue-green&hide_border=true&include_all_commits=true&count_private=true"
        ></Image>
      </Stack>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        GitHub <strong className="yellow">Streaks</strong>
      </h1>

      <Stack mt="70px">
        <Image
          height={"300px"}
          id="github-streak-stats"
          src="https://github-readme-streak-stats.herokuapp.com/?user=Prabhat-kumar-11&theme=blue-green&hide_border=true"
        ></Image>
      </Stack>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        GitHub <strong className="yellow">Languages</strong>
      </h1>

      <Stack mt="70px">
        <Image
          height={"300px"}
          id="github-top-langs"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=Prabhat-kumar-11&theme=blue-green&hide_border=true&include_all_commits=true&count_private=true&layout=compact"
        ></Image>
      </Stack>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        GitHub <strong className="yellow">Trophies</strong>
      </h1>
      <Stack mt="70px" style={{padding: "0px 15px"}}>
        <div>
          <Image
            width={"100%"}
            src="https://user-images.githubusercontent.com/73097560/115834477-dbab4500-a447-11eb-908a-139a6edaec5c.gif"
          ></Image>
        </div>

        <Image
          height={"150px"}
          src="https://github-profile-trophy.vercel.app/?username=Prabhat-kumar-11&theme=radical&no-frame=false&no-bg=false&margin-w=4"
        ></Image>

        <div>
          <Image
            width={"100%"}
            src="https://user-images.githubusercontent.com/73097560/115834477-dbab4500-a447-11eb-908a-139a6edaec5c.gif"
          ></Image>
        </div>
      </Stack>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        GitHub <strong className="yellow">Calendar</strong>
      </h1>
      <div style={{ display: "flex", justifyContent: "center", padding: "0px 15px" }}>
        <GitHubCalendar
          username="Prabhat-kumar-11"
          
          blockSize={15}
          blockMargin={5}
          color="#6102ce"
          fontSize={16}
        />
      </div>
    </div>
  );
};

export default Github;
